import React, {useState} from 'react';
import { Link} from 'react-router-dom';
import {auth} from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useAuth } from '../context/AuthContext';
import './Home.css';
import './Auth.css'

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { setUser } = useAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            setUser(userCredential.user)
        } catch (err) {
            setError("Hold there, traveler! Your papers don't check out. Reconfirm your credentials.");
            console.error("Error logging in:", err.message);
        }
    };

    return (
        <div className='home-container'>
            <h1>Identify Yourself!</h1>
            {error && <p className='form-error'>{error}</p>}
            <form onSubmit={handleLogin} className='auth-form'>
                <input type="email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder='Email'
                required 
                className='auth-input'/>
                <input type="password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder='Password'
                required 
                className='auth-input'/>
                <button type='submit' className='home-button'>Log In</button>
            </form>
            <p className='auth-link'>
                Need an accout? Register to the guild here! <Link to="/signup">Sign Up</Link>
            </p>
        </div>
    );
}

export default Login;